var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "bg-blue-dark pt-2 pb-2 webstore-footer" },
    [
      _c("nav", [
        _c(
          "div",
          { staticClass: "flex-col flex flex-wrap justify-between lang-wrap" },
          [
            _c("div", { staticClass: "flex flex-wrap footer__legal" }, [
              _c(
                "ul",
                { staticClass: "flex flex-wrap px-gap mx-0 my-1 pl-0 legal" },
                _vm._l(_vm.links, function (link, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "mb-1/2 font-light text-white legal-links",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "text-white text-sm",
                          attrs: { href: link.href },
                        },
                        [
                          _vm._v(_vm._s(link.text)),
                          link?.img
                            ? _c("img", {
                                staticClass: "inline ml-1/4 lazyLoad isLoaded",
                                attrs: { src: link.img, alt: link?.alt },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("p", { staticClass: "copyright text-white" }, [
              _vm._v("© 2023 Samsara Inc."),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "xs-12 col space-top-0 white-text footer__mobile-logo" },
      [
        _c("div", { staticClass: "logo-container visible-m" }, [
          _c("a", {
            staticClass: "footer-logo",
            attrs: { href: "/", title: "samsara" },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }